<div class="tw-relative tw-flex tw-h-full tw-gap-4" [routerLink]="'../customer/' + customer?.uuid">
  <div [ngClass]="customer?.isArchived ? 'tw-text-slate-500' : 'tw-text-slate-600'" class="tw-mr-auto tw-flex tw-min-w-0 tw-flex-col">
    <h4
      [ngClass]="customer?.isArchived ? 'tw-text-slate-600' : 'tw-text-slate-800'"
      class="tw-mb-3 tw-truncate tw-text-lg tw-font-bold lg:tw-text-xl">
      {{ customer | fullname }}
    </h4>
    <div class="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-truncate"><ate-icon class="tw-size-4 tw-shrink-0" name="phone-v2"></ate-icon>{{ mobileNumber }}</div>
    <div class="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-truncate"><ate-icon class="tw-size-4 tw-shrink-0" name="email-v3"></ate-icon>{{ email }}</div>
    <div class="tw-flex tw-w-fit tw-gap-2">
      @if (statusConfig) {
        <span
          [ngClass]="statusConfig?.classes"
          class="tw-truncate tw-rounded-2xl tw-p-1 tw-px-2 tw-text-sm tw-font-semibold">
          {{ statusConfig.name }}
        </span>
      }
      @if (customer?.isArchived) {
        <span
          class="tw-truncate tw-rounded-2xl tw-bg-slate-100 tw-p-1 tw-px-2 tw-text-sm tw-font-semibold tw-text-slate-800">
          Archived
        </span>
      }
    </div>
  </div>

  <div class="tw-flex tw-flex-col tw-justify-between">
    <ate-button-control
      (click)="editCustomer($event)"
      title="Edit Customer"
      class="tw-h-11 tw-w-fit tw-min-w-0 tw-p-2.5"
      color="secondary">
      <ate-icon class="tw-size-5 tw-shrink-0" name="edit-v3"></ate-icon>
    </ate-button-control>

    <ate-button-control
      (click)="customer?.isArchived ? setArchiveStatus($event, false) : openConfirmationModal($event)"
      [title]="customer?.isArchived ? 'Unarchive Enquiry' : 'Archive Enquiry'"
      class="tw-h-11 tw-w-fit tw-min-w-0 tw-p-2.5"
      color="secondary">
      @if (isSetArchiveLoading) {
        <ate-icon class="tw-size-5 tw-shrink-0 tw-animate-spin tw-text-white" name="loading-spinner-gradient-v3"></ate-icon>
      } @else {
        <ate-icon class="tw-size-5 tw-shrink-0" [name]="customer?.isArchived ? 'unarchive' : 'archive-v3'"></ate-icon>
      }
    </ate-button-control>
  </div>
</div>